import {AuthModel} from '../auth/core/_models'
import {isOnPremisesInstallation} from '../auth/core/onPremisesAccess'
import {businessSettingsPath} from '../online-payment/core/businessSettingsPath'
import {periodicReportsPath} from '../business-services/core/periodicReportsPath'

/**
 * «اعلان‌های صورتحساب» and «گزارش دوره‌ای» in «امکانات تازه» (2026-10-15): like buyer links, the header's icon shakes
 * until the list is opened, and each item opens its own introduction (BusinessServicesIntroGates).
 */
export const INVOICE_ALERTS_INTRO_EVENT = 'mp:invoice-alerts-intro'
export const PERIODIC_REPORTS_INTRO_EVENT = 'mp:periodic-reports-intro'

/** The announcements' ids in the user's seen list (whatsNewSeen); a new announcement takes a new id. */
export const INVOICE_ALERTS_ANNOUNCEMENT = 'invoice-alerts-1405-07'
export const PERIODIC_REPORTS_ANNOUNCEMENT = 'periodic-reports-1405-07'

export const openInvoiceAlertsIntro = (): void => {
  window.dispatchEvent(new Event(INVOICE_ALERTS_INTRO_EVENT))
}

export const openPeriodicReportsIntro = (): void => {
  window.dispatchEvent(new Event(PERIODIC_REPORTS_INTRO_EVENT))
}

/** «اعلان‌های کارپوشه و تأیید خودکار صورتحساب‌های خرید» (2026-10-17), announced the same way. */
export const TAX_WORKSPACE_ALERTS_INTRO_EVENT = 'mp:tax-workspace-alerts-intro'
export const TAX_WORKSPACE_ALERTS_ANNOUNCEMENT = 'tax-workspace-alerts-1405-07'

export const openTaxWorkspaceAlertsIntro = (): void => {
  window.dispatchEvent(new Event(TAX_WORKSPACE_ALERTS_INTRO_EVENT))
}

/**
 * Whoever works in a business on the central panel, outside a support session: both services are set per
 * business, charge its wallet and do not exist on premises.
 */
export const shouldAnnounceBusinessServices = (user?: AuthModel | null) =>
  Boolean(user && !user.support && Number(user.cpi || 0) > 0 && !isOnPremisesInstallation(user))

/** «تنظیمات کسب‌وکار ← اعلان‌های صورتحساب» of a business. */
export const invoiceAlertsSettingsPath = (companyId: number) =>
  businessSettingsPath(companyId, 'invoice-alerts')

/** «تنظیمات کسب‌وکار ← اعلان‌های کارپوشه و تأیید خودکار» of a business. */
export const taxWorkspaceAlertsSettingsPath = (companyId: number) =>
  businessSettingsPath(companyId, 'tax-workspace-alerts')

/** «گزارش‌ها ← گزارش‌های دوره‌ای» of a business. */
export const periodicReportsIntroPath = (companyId: number) => periodicReportsPath(companyId)
